/*
 * קבועי הרשת.
 *
 * **תור רשת אינו טיק.** הסימולציה רצה ב-20Hz, אבל שליחת הודעה לכל טיק היא גם בזבוז
 * רוחב פס וגם — בענן — בזבוז מכסה: ב-Cloudflare כל הודעת WebSocket נספרת כבקשה.
 * לכן הפקודות נצברות לתור, ותור אחד מכסה כמה טיקים.
 *
 * **הפקודות של תור נכנסות כולן בטיק הראשון שלו.** זה מה שמאפשר לשני הצדדים לגזור
 * את הטיק המדויק ממספר התור בלבד, בלי שהוא ייסע ברשת ובלי שאפשר יהיה לחלוק עליו.
 */

/** גרסת הפרוטוקול. צד עם גרסה אחרת נדחה ברעש ולא מדבר חצי-שפה. */
export const PROTOCOL_VERSION = 1;

/**
 * כמה טיקים בתור אחד — **החלטת מוצר, לא כוונון.**
 *
 * הקבוע הזה קונה זמן משחק במטבע של תחושת תגובה, ושני הצדדים שלו נמדדים:
 *
 * | טיקים לתור | אורך תור | הודעות/שנייה | משחק ליום במכסה החינמית | השהיית קלט |
 * |---|---|---|---|---|
 * | 2 | 100ms | ~40 | ~40 דקות | ~200ms |
 * | **3** | **150ms** | **~27** | **~1 שעה** | **~300ms** |
 * | 5 | 250ms | ~16 | ~1.7 שעות | ~500ms |
 *
 * המכסה היא 100,000 בקשות ליום **לכל חשבון Cloudflare**, וכל הודעת WebSocket
 * נספרת — נכנסת ויוצאת. שלוש הוא הפשרה: משחקי ה-RTS של התקופה חיו על ~250ms
 * השהיה, וחצי שנייה כבר מרגישה כמו "המשחק לא מגיב".
 *
 * **משחק יחיד אינו שולח דבר** — המכסה נוגעת אך ורק למולטיפלייר.
 */
export const TURN_TICKS = 3;

/**
 * כמה תורות מראש נסגרות הפקודות.
 *
 * זו השהיית הקלט של המולטיפלייר: פקודה שנשלחת בתור t מתבצעת בתור t+TURN_LEAD,
 * כלומר `TURN_LEAD × TURN_TICKS` טיקים אחרי הלחיצה (300ms בברירת המחדל). גדול יותר מ-`INPUT_DELAY_TICKS` של השחקן היחיד (2 טיקים)
 * ובכוונה — ההפרש הוא בדיוק החלון שבו ההודעה אמורה לחצות את הרשת.
 *
 * **זה גם מה שמונע נעילה הדדית:** צד רשאי לרוץ עד TURN_LEAD תורות לפני זה שממולו,
 * ולכן שניהם תמיד כבר שלחו את התור שהשני ממתין לו.
 */
export const TURN_LEAD = 2;

/**
 * כל כמה טיקים מחליפים גיבוב מצב.
 *
 * לא מעכב את המשחק — הוא אבחון בלבד. 100 טיקים = 5 שניות, מספיק צפוף כדי לתפוס
 * פיצול לפני שהוא הופך לשני משחקים שונים לגמרי, ודליל מספיק כדי לא להעיק.
 */
export const HASH_INTERVAL_TICKS = 100;

/** אחרי כמה זמן של המתנה לשחקן מפגר מכריזים עליו כאבוד. */
export const PEER_TIMEOUT_MS = 15_000;

/** כמה תורות אחורה שומרים לפני שמפנים. מספיק להשלמת פיגור, לא יותר. */
export const TURN_HISTORY = TURN_LEAD * 4;

export function turnOf(tick: number): number {
    return Math.floor(tick / TURN_TICKS);
}

export function turnStartTick(turn: number): number {
    return turn * TURN_TICKS;
}

export function isTurnStart(tick: number): boolean {
    return tick % TURN_TICKS === 0;
}
